import {HttpServiceResponse} from 'vue3-starter/src/typescript/http/http';
import {context} from 'vue3-starter/src/typescript/app-context/AppContext';

export class FreelancerSkillsService {
    async retrieveSuggestions(category: string, job?: string | null): Promise<HttpServiceResponse<string[]>> {
        return await context.httpService.post<string[]>(context.registry.entries.suggestTags(), {
            category,
            job,
        });
    }

    async search(query: string): Promise<HttpServiceResponse<string[]>> {
        const [data, error] = await context.httpService.post<string[]>(context.registry.entries.tags(), {query});
        if (error || !data) {
            return [null, error];
        }
        if (!data.includes(query)) {
            return [[...data, query], null];
        }
        return [data, null];
    }
}
